import React, { useCallback, useEffect, useRef } from 'react';
import JsBarCode from 'jsbarcode';
const BarCode = function BarCode(props) {
    const { value, renderAs = 'canvas', bgColor, fgColor, option } = props;
    const canvasBarCodeRef = useRef(null);
    const svgBarCodeRef = useRef(null);
    const renderCode = useCallback(() => {
        try {
            const canvasRef = canvasBarCodeRef.current;
            const svgRef = svgBarCodeRef.current;
            if (canvasRef || svgRef)
                JsBarCode(renderAs === 'canvas' ? canvasRef : svgRef, value, {
                    ...option,
                    background: option?.background || bgColor,
                    lineColor: option?.lineColor || fgColor,
                });
        }
        catch (error) {
            console.warn(error);
        }
    }, [canvasBarCodeRef, svgBarCodeRef]);
    useEffect(() => {
        renderCode();
    }, [renderCode()]);
    if (renderAs === 'canvas') {
        return React.createElement("canvas", { ref: canvasBarCodeRef });
    }
    return React.createElement("svg", { ref: svgBarCodeRef });
};
export default BarCode;
